<div class="alert alert-info" ng-show="vm.documents.length == 0">Keine Daten gefunden</div>

<!--table-->
<!-- Must use ng-if to display, ng-show will not render automatically, only after resize -->
<div class="gridStyle documentGrid" ui-grid="vm.gridOptions" ng-if="vm.documents.length > 0"></div>
<div class="comfortspace">&nbsp;</div>

<!-- template for tags cell -->
<script type="text/ng-template" id="documenttagtemplate">
    <tags-input ng-model="row.entity.keywords"
                display-property="text"
                id="documentkeywords{{$index}}"
                add-on-paste="true"
                add-on-comma="false"
                add-on-enter="true"
                min-length="1"
                ng-blur="grid.appScope.vm.saveDocument(row.entity)"
                enable-editing-last-tag="true"
                add-from-autocomplete-only="false"
                replace-spaces-with-dashes="false"
                template="documenttag-template">
        <auto-complete source="grid.appScope.vm.getTags($query)"
                       min-length="1"
                       load-on-focus="true"
                       load-on-empty="false"
                       load-on-down-arrow="true"
                       max-results-to-show="32"
                       select-first-match="true"
                       template="documenttagautocomplete-template">
        </auto-complete>
    </tags-input>
</script>


<!--template for action buttons-->
<script type="text/ng-template" id="documentactiontemplate">
    <div class="ui-grid-cell-contents">
    <span style="text-align: right">
        <a href="/routes/pdfreader/{{row.entity._id}}" target="_blank" class="btn btn-primary btn-xs"><i
            class="fa fa-eye"></i></a>
        <a href="/routes/pdfdownload/{{row.entity._id}}" class="btn btn-primary btn-xs"><i
            class="fa fa-download"></i></a>
        <!-- delete document, mit Rückfrage -->
<!--        <a ng-really-click="grid.appScope.vm.removeDocument(row.entity, $index)"
           ng-really-message="Wollen Sie dieses Dokument wirklich l&ouml;schen?"
           class="btn btn-danger btn-xs">
            <i class="fa fa-remove"></i>
        </a>-->
        <!-- unlink document, mit Rückfrage -->
<!--        <a ng-really-click="grid.appScope.vm.unlinkdocument(row.entity, $index)"
           ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"
           class="btn btn-warning btn-xs">
            <i class="fa fa-unlink"></i>
        </a><sprhelp tip="Dateizuordnung aufheben" descref="grid.appScope.vm.helpunlink"></sprhelp>-->
      </span>
    </div>
</script>

<!-- tag template -->
<script type="text/ng-template" id="documenttag-template">
    <div class="tag-template">
        <div class="right-panel">
            <span>{{$getDisplayText()}}</span>
            <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
        </div>
    </div>
</script>

<!-- tag autocomplete template -->
<script type="text/ng-template" id="documenttagautocomplete-template">
    <div class="documenttagautocomplete-template" style="z-index: 10000!important">
        <div>
            <span ng-bind-html="$highlight($getDisplayText())">{{text}}</span>
        </div>
    </div>
</script>